import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Handle chunk load failures gracefully
// This occurs when a new deployment happens and old chunks are removed from the server
window.addEventListener('vite:preloadError', (event) => {
  console.warn('Vite preload error detected, forcing reload...', event);
  window.location.reload();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
